import { FaFacebookF, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

export default [
  {Icon: FaFacebookF, background: '#375896', link: 'https://www.facebook.com/techsonthemove/'},
  {Icon: FaLinkedin, background: '#8DC5D7', link: 'https://www.linkedin.com/company/techs-on-the-move'},
  {Icon: FaInstagram, background: '#D2003C', link: 'https://www.instagram.com/techsonthemove/'},
  {Icon: FaYoutube, background: '#FF0000', link: 'https://www.youtube.com/techsonthemove'},
]
